import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Grid, Card, CardMedia, CardContent, Typography, Container, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Loading from './Loading';

const SmugMugGallery = () => {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlbums = async () => {
      try {
        // Request AlbumHighlightImage to be expanded
        const url = `${process.env.REACT_APP_SMUGMUG_API_URL}?smugmug_path=/user/mruns!albums&_expand=AlbumHighlightImage`;
        console.log("Fetching albums from URL:", url); // Debugging line
        const response = await axios.get(url);
        console.log("Raw API Response:", response.data); // Debugging line
        
        if (response.data && response.data.Response.Album) {
          const publicAlbums = response.data.Response.Album.filter(album => album.SecurityType === 'None');
          const expansions = response.data.Expansions || {}; // Get the expansions object
          console.log("Expansions object:", expansions); // Debugging line

          const albumsWithThumbnails = publicAlbums.map(album => {
            let highlightImageUrl = 'https://source.unsplash.com/random?landscape'; // Default fallback

            if (album.Uris?.AlbumHighlightImage?.Uri) {
              const albumHighlightImageUri = album.Uris.AlbumHighlightImage.Uri;
              console.log("AlbumHighlightImage URI:", albumHighlightImageUri); // Debugging line
              const expandedAlbumImage = expansions[albumHighlightImageUri];
              console.log("Expanded AlbumImage object:", expandedAlbumImage); // Debugging line

              if (expandedAlbumImage && expandedAlbumImage.AlbumImage?.ThumbnailUrl) {
                highlightImageUrl = expandedAlbumImage.AlbumImage.ThumbnailUrl;
                console.log("Found ThumbnailUrl:", highlightImageUrl); // Debugging line
              } else {
                console.log("ThumbnailUrl not found in expandedAlbumImage for album:", album.Name); // Debugging line
              }
            } else {
              console.log("AlbumHighlightImage URI not found for album:", album.Name); // Debugging line
            }
            return { ...album, highlightImageUrl: highlightImageUrl };
          });
          setAlbums(albumsWithThumbnails);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching SmugMug albums via proxy:", error);
        setLoading(false);
      }
    };

    fetchAlbums();
  }, []);

  if (loading) {
    return <Container sx={{ py: 4 }}><Loading /></Container>;
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
        Photo Albums
      </Typography>
      <Grid container spacing={4}>
        {albums.map((album) => {
          const imageUrl = album.highlightImageUrl;
          
          return (
            <Grid item key={album.AlbumKey} xs={12} sm={6} md={4}>
              <Link component={RouterLink} to={`/photos/${album.AlbumKey}`} sx={{ textDecoration: 'none' }}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', '&:hover': { transform: 'scale(1.03)', transition: 'transform 0.2s ease-in-out' } }}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={imageUrl}
                    alt={album.Name}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                      {album.Name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {album.ImageCount} photos
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default SmugMugGallery;
